import { ProfileState } from '../state/profile.state';
import { Store } from '@ngxs/store';
import { catchError, filter, first, Observable, of, timeout } from 'rxjs';

export const PROFILE_USER_TYPE_TIMEOUT_MS = 5000;

export const waitForProfileUserType = (
  store: Store,
): Observable<string | undefined> =>
  store.select(ProfileState.getUserType).pipe(
    filter((userType): userType is string => !!userType),
    first(),
    timeout({ first: PROFILE_USER_TYPE_TIMEOUT_MS }),
    catchError(() => of(undefined)),
  );
